<script>
import { required, numeric } from "vuelidate/lib/validators";
import validationMessages from "@/components/validations";
import Merchandising from "@/services/Merchandising";
import Multiselect  from "vue-multiselect";
import Swal from "sweetalert2";
import id from "vue2-datepicker/locale/es/id";

export default {
  props:['id','categories','name'],
  components: { Multiselect, validationMessages },
  validations:{
    selectedCategories: { required },
  },
  data() {
    return {
      brand_name: "",
      showModal: false,
      submitted: false,
      isBusy: false,
      tryingToSubmit: false,
      showLoader: false,
      csrf_token: localStorage.getItem("csrf_token"),
      attrID:'',
      attrCategories:[],
      attrName:'',
      categoriesData:[],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      selectedCategories:'',
      formatedCategories:[],
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "created_on",
      tableData: [],
      sortDesc: true,
      fields: [

        {
          key: "category_id",
          label: "Category ID",
          sortable: true,
        },
        {
          key: "category_name",
          label: "Category Name",
          sortable: true,
        },

        "action"
      ],


    };
  },

  computed:{
    filteredCategories(){
      if(!this.attrCategories || this.attrCategories.length === 0){
        return this.formatedCategories
      }

      const linkedCategoryIds = this.attrCategories.map(cat =>
          cat.category_id || cat.id || cat.ID_Grupa || cat.ID_PodGrupa
      );
      return this.formatedCategories.filter(category =>
          !linkedCategoryIds.includes(category.id)
      );
    }
  },
  methods: {

    async submitForm() {
      this.tryingToSubmit = true;

      if (this.$v.$invalid) {
        this.submitted = true;
        this.tryingToSubmit = false;
        return;
      }
      const categoryIds = this.selectedCategories.map(category => category.id);
      this.showLoader = true;
      const data = {
        attr_id: this.attrID,
        category_ids: categoryIds,
      }
      try {
        const response = await Merchandising.linkAttributeToCategories(data);
        if (response.success === false) {
          Swal.fire("Error", response.error || "Failed to link attribute. Please try again.", "error");
        } else {
          Swal.fire("Success", "Attribute successfully linked!", "success");
          this.closeModal();
          this.refreshData();
        }

      } catch (error) {
        // Catch any network or unexpected errors
        console.error("Failed to create attribute:", error);
        Swal.fire("Error", error.response?.data?.error || "Failed to create attribute. Please try again.", "error");
      } finally {
        this.tryingToSubmit = false;
        this.showLoader = false;
      }
    },

    async unlinkCategory(attr_id,category_id) {
      console.log(attr_id);
      Swal.fire({
        title: "Unlink Category?",
        text: "This Category will be unlinked from this attribute!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Unlink!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const data = `?attr_id=${attr_id}&category_id=${category_id}`;
            const response = await Merchandising.unlinkCategoryFromAttribute(data);
            if (response.data) {
              Swal.fire("Success!", "Category is successfully unlinked !", "success");
              this.refreshData();
              this.closeModal()
            } else {
              let errorMessage = response.error ? response.error : 'Failed';
              if (typeof errorMessage === 'object') {
                errorMessage = errorMessage[0];
              }
              Swal.fire("Fail!", errorMessage, "warning");
            }
          } catch (error) {
            let errorMessage = error.response && error.response.data && error.response.data.error
                ? error.response.data.error
                : "An error occurred while unlinking category!";
            if (typeof errorMessage === 'object') {
              errorMessage = errorMessage[0];
            }
            Swal.fire("Error", errorMessage, "error");
          }
        }
      });
    },

    resetForm() {
      this.$v.$reset();
      this.attrCategories=[];
      this.attrID= '';
      this.attrName = '';
      this.selectedCategories = [];


    },

    closeModal() {
      this.resetForm();
      this.showModal = false;
    },
    flattenCategories(categories) {
      const result = []

      Object.values(categories).forEach(cat => {
        // main category
        result.push({ id: cat.ID_Grupa, name: cat.name })

        if (cat.subcategories) {
          Object.values(cat.subcategories).forEach(sub => {
            // sub category
            result.push({ id: sub.ID_PodGrupa, name: sub.name })

            if (sub.subsubcategories) {
              Object.values(sub.subsubcategories).forEach(subsub => {
                result.push({ id: subsub.category_id, name: subsub.category_name })
              })
            }
          })
        }
      })

      return result
    },
    async getCategories(){
      try {
        const response = await Merchandising.getCategories();
        this.categoriesData = response.data.data;
        this.formatedCategories = this.flattenCategories(this.categoriesData);
      }catch (error){
        console.log(error);
      }
    },




    refreshData() {
      this.$emit("onRefresh");
    },
    async syncData(){
      this.attrID = this.id; // Update local ID when modal is shown
      this.attrCategories = this.categories
      this.attrName = this.name;
      this.tableData = this.attrCategories
      this.totalRows = this.attrCategories.length;
      await this.getCategories();
    }

  },

};
</script>

<template>
  <b-modal
      @hidden="resetForm"
      @shown="syncData"
      id="link_attribute"
      size="xl"
      v-model="showModal"
      title="Link Categories to Attribute"
      title-class="font-18"
  >
    <form @submit.prevent="submitForm">
      <div class="row">

        <div class="row" >
          <div id="right_side" class="col-6">
            <h5 style="margin-bottom:40px;">Attribute: {{attrName}}</h5>
            <b-form-group >
              <label class="typo__label" for="ajax">Category</label>
              <multiselect v-model="selectedCategories"
                           label="name"
                           track-by="id"
                           placeholder="Type to search categories"
                           :multiple="true"
                           :options="filteredCategories"
                           :searchable="true"
                           :loading="showLoader"
                           :internal-search="true"
                           :clear-on-select="false"
                           :close-on-select="false"
                           :options-limit="300"
                           :max-height="600"
                           :show-no-results="false"
                           :hide-selected="true"
                           :class="{ 'is-invalid': submitted && $v.selectedCategories.$error }">
                <template slot="tag" slot-scope="{ option, remove }">
                    <span class="custom__tag">
                        <span>{{ option.name }}</span>
                        <span class="custom__remove" @click="remove(option)">✖</span>
                    </span>
                </template>
              </multiselect>
              <validationMessages v-if="submitted" :fieldName="'Category'" :validationName="$v.selectedCategories"></validationMessages>

            </b-form-group>
          </div>
          <div id="left_side" class="col-6">
            <h5 class="text-center">Linked Categories To {{attrName}}</h5>
            <!-- Search -->
            <div class="col-sm-12 col-md-12">
              <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
              >
                <label class="d-inline-flex align-items-center">
                  Search:
                  <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                  ></b-form-input>
                </label>
              </div>
            </div>
            <!-- End search -->
            <div class="table-responsive mb-0">
              <b-table
                  :items="tableData"
                  :busy="isBusy"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  show-empty
                  empty-text="No Data Found"
              >


                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(action)="data">
                  <ul class="list-inline">
                    <li class="list-inline-item">
                      <a href="javascript:void(0);" @click="unlinkCategory(attrID, data.item.category_id)"  title="Unlink Category">
                        <span class="d-none">{{data}}</span>
                        <i class="uil uil-link-broken font-size-18"></i>
                      </a>
                    </li>
                  </ul>
                </template>
              </b-table>
            </div>


            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
      <b-button variant="primary" @click="submitForm" :disabled="tryingToSubmit || showLoader">
        <b-spinner v-show="tryingToSubmit" small></b-spinner>Submit
      </b-button>
    </template>
  </b-modal>
</template>
